module.exports = __webpack_public_path__ + "avans.png?4d23cecf5d72928164f1e2d42c22a818";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avans.png
// module id = 952
// module chunks = 2